// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__3DKyZ"};